module.exports = __webpack_public_path__ + "static/gallery_09-thumb-e554c44ac7b7daaf292b28aaa12573fe.jpg";